export const paymentMethods = {
    mpesa: "mpesa",
    paypal: "paypal"
}